import { useState } from "react";
import Modal from "../../../../components/Modal";
import ShowButton from "../../../../components/ShowButton";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetEmailLogsByEventId from "../hooks/useGetEmailLogsByEventId";
import EmailLogsViewModal from "./EmailLogsViewModal";

const EmailLogDetailsTable = ({ data }) => {
  const [isShow, setShow] = useState(false);
  const [row, setRow] = useState([]);
  const handleShow = (rowData) => {
    setRow(rowData);
    setShow(true);
  };
  const handleCloseEmailModal = () => {
    setShow(false);
  };
  const { data: emailLogsData, isLoading } = useGetEmailLogsByEventId(
    data.eventId ?? 0
  );
  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;
  const columns = [
    {
      title: "Status",
      field: "status",
    },
    {
      title: "Created By",
      field: "createdBy",
    },
    {
      title: "Created Date",
      field: "createdDate",
    },
    {
      title: "Actions",
      field: "actions",
      align: alignCenter,
      render: (rowData) => {
        return (
          <div className="flex place-content-center mr-5">
            <ShowButton
              buttonText="Show"
              className={
                "flex space-x-1 justify-start expandedLabel fontExpand"
              }
              disabled={undefined}
              onClick={() => {
                handleShow(rowData);
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="w-full p-2 bg-white">
      <div className="overflow-x-auto grid grid-row">
        <MaterialTableTS
          columns={columns}
          data={emailLogsData}
          isLoading={isLoading}
          selection={false}
          showTitle={false}
          exportButton={false}
          grouping={undefined}
          detailPanel={undefined}
          selectedRows={[]}
          onSelectionChange={undefined}
          paging={true}
          searchFieldAlignment={undefined}
          toolBarComponent={undefined}
          tableRef={undefined}
          onSearchChange={undefined}
          title={undefined}
        />
      </div>
      {isShow && (
        <Modal
          isCloseHide={false}
          modalFilterStat=""
          className=""
          width={"100"}
          title={""}
          isOpen={isShow}
          onClose={handleCloseEmailModal}
          hasCloseButton={false}
        >
          <EmailLogsViewModal
            data={row}
            closeEmailLogsModal={handleCloseEmailModal}
          />
        </Modal>
      )}
    </div>
  );
};

export default EmailLogDetailsTable;
